/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wrapped_Not_Ready_TitleInputs */

const en_us2_wrapped_not_ready_title = /** @type {(inputs: Wrapped_Not_Ready_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your first retrospective arrives on Sunday`)
};

const pt_br2_wrapped_not_ready_title = /** @type {(inputs: Wrapped_Not_Ready_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sua primeira retrospectiva sai no domingo`)
};

const es_419_wrapped_not_ready_title = /** @type {(inputs: Wrapped_Not_Ready_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu primer resumen llega el domingo`)
};

const pt_pt2_wrapped_not_ready_title = /** @type {(inputs: Wrapped_Not_Ready_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A tua primeira retrospetiva chega no domingo`)
};

const fr_fr2_wrapped_not_ready_title = /** @type {(inputs: Wrapped_Not_Ready_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ton premier bilan arrive dimanche`)
};

const de_de2_wrapped_not_ready_title = /** @type {(inputs: Wrapped_Not_Ready_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dein erster Rückblick kommt am Sonntag`)
};

const it_it2_wrapped_not_ready_title = /** @type {(inputs: Wrapped_Not_Ready_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il tuo primo riepilogo arriva domenica`)
};

/**
* | output |
* | --- |
* | "Your first retrospective arrives on Sunday" |
*
* @param {Wrapped_Not_Ready_TitleInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const wrapped_not_ready_title = /** @type {((inputs?: Wrapped_Not_Ready_TitleInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wrapped_Not_Ready_TitleInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_wrapped_not_ready_title(inputs)
	if (locale === "es-419") return es_419_wrapped_not_ready_title(inputs)
	if (locale === "pt-PT") return pt_pt2_wrapped_not_ready_title(inputs)
	if (locale === "fr-FR") return fr_fr2_wrapped_not_ready_title(inputs)
	if (locale === "de-DE") return de_de2_wrapped_not_ready_title(inputs)
	if (locale === "it-IT") return it_it2_wrapped_not_ready_title(inputs)
	return en_us2_wrapped_not_ready_title(inputs)
});
export { wrapped_not_ready_title as "wrapped.not_ready_title" }